import cn from 'classnames';

import type { ContentSummary as ContentSummaryType, AgentHitType } from '~/types/agent';

import Spacer from '@helsenorge/designsystem-react/components/Spacer';
import Title from '@helsenorge/designsystem-react/components/Title';
import designsystemtypography from '@helsenorge/designsystem-react/scss/typography.module.scss';

import Hits from './hits';
import Tjenester from './tjenester';

import styles from './styles.module.scss';

interface ContentSummaryProps {
  summary: ContentSummaryType;
  returnUrl: string;
  onResultClick?: (title: string, hitType: AgentHitType) => void;
  resources: {
    summaryTitle: string;
    linksTitle: string;
    actionsTitle: string;
    returnUrlText: string;
    goToTjeneste: string;
    goToVerktoy: string;
  };
}

const ContentSummary: React.FC<ContentSummaryProps> = props => {
  return (
    <div className={styles['content-summary']}>
      {props.summary.s1 && (
        <div>
          <Title htmlMarkup="h2" appearance="title3" margin={0}>
            {props.resources.summaryTitle}
          </Title>
          <Spacer size={'xs'} />
          <p className={cn(designsystemtypography.preamble, styles['content-summary__preamble'])}>{props.summary.s1}</p>
        </div>
      )}

      {props.summary.s3.length > 0 && (
        <div>
          <Title htmlMarkup="h2" appearance="title4" margin={0}>
            {props.resources.linksTitle}
          </Title>
          <Spacer size={'xs'} />
          <Hits
            links={props.summary.s3}
            returnUrlText={props.resources.returnUrlText}
            returnUrl={props.returnUrl}
            onResultClick={props.onResultClick}
          />
        </div>
      )}

      {props.summary.s4.length > 0 && (
        <div>
          <Title htmlMarkup="h2" appearance="title4" margin={0}>
            {props.resources.actionsTitle}
          </Title>
          <Tjenester
            links={props.summary.s4}
            returnUrlText={props.resources.returnUrlText}
            returnUrl={props.returnUrl}
            onResultClick={props.onResultClick}
            resources={{ goToTjeneste: props.resources.goToTjeneste, goToVerktoy: props.resources.goToVerktoy }}
          />
        </div>
      )}
    </div>
  );
};

export default ContentSummary;
